import { render, staticRenderFns } from "./ContactGroupsManagement.vue?vue&type=template&id=4eb3d9ae&"
import script from "./ContactGroupsManagement.vue?vue&type=script&lang=js&"
export * from "./ContactGroupsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports